import { render } from "./intro.vue?vue&type=template&id=2585d31e"
const script = {}

import "./intro.vue?vue&type=style&index=0&id=2585d31e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__